export default "__VITE_ASSET__d8ulpAYX__"